"use client";

import { cn } from "@/lib/utils";
import makeSlug from "@/utils/makeSlug";
import { useMarket } from "@app/_context";
import useTranslate from "@app/_hooks/useTranslate";
import { Button } from "@ui/button";
import { DialogTrigger } from "@ui/dialog";
import { type ComponentProps } from "react";
import useAuth from "../hooks/useAuth";
import useSignOut from "../hooks/useSignOut";
import DesktopSignIn from "./DesktopSignIn";

export default function AuthToggle({
  className,
  ...props
}: ComponentProps<typeof Button>) {
  const t = useTranslate();
  const { market } = useMarket().state;
  const { user } = useAuth();
  const signOut = useSignOut();

  return (
    <DesktopSignIn>
      {user ? (
        <Button
          className={cn("p-0 text-left", className)}
          onClick={() =>
            signOut({
              redirectTo: makeSlug(market.locale),
            })
          }
          {...props}
        >
          {t("signOut")}
        </Button>
      ) : (
        <DialogTrigger asChild>
          <Button className={cn("p-0 text-left", className)} {...props}>
            {t("login")}
          </Button>
        </DialogTrigger>
      )}
    </DesktopSignIn>
  );
}
